
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 512.005 512","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M505.75 475.586L360.148 329.988c28.204-34.84 45.184-79.105 45.184-127.32C405.332 90.926 314.41.004 202.668.004 90.922.004 0 90.926 0 202.668c0 111.746 90.922 202.668 202.668 202.668 48.21 0 92.48-16.98 127.316-45.184l145.602 145.602a21.283 21.283 0 0015.082 6.25 21.29 21.29 0 0015.082-6.25c8.34-8.344 8.34-21.824 0-30.168zM282.668 224.004H224v58.664c0 11.777-9.559 21.336-21.332 21.336-11.777 0-21.336-9.559-21.336-21.336v-58.664h-58.664c-11.777 0-21.336-9.559-21.336-21.336 0-11.773 9.559-21.332 21.336-21.332h58.664v-58.668c0-11.773 9.559-21.332 21.336-21.332 11.773 0 21.332 9.559 21.332 21.332v58.668h58.668c11.773 0 21.332 9.559 21.332 21.332 0 11.777-9.559 21.336-21.332 21.336zm0 0"}})])
          )
        }
      }
    